import { render, staticRenderFns } from "./SingInSSOPage.vue?vue&type=template&id=ecce183a&"
import script from "./SingInSSOPage.vue?vue&type=script&lang=js&"
export * from "./SingInSSOPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports